import { render, staticRenderFns } from "./TrendyolPlayer.vue?vue&type=template&id=1e222b2d&scoped=true&"
import script from "./TrendyolPlayer.vue?vue&type=script&lang=js&"
export * from "./TrendyolPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TrendyolPlayer.vue?vue&type=style&index=0&id=1e222b2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e222b2d",
  null
  
)

export default component.exports